import React from 'react';
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';

const IframeConstructorRangeControl = ({ value, name, onChange, max, min, disabled, step = 5 }) => (
  <div className="ic-range-container">
    <InputRange
      maxValue={max}
      minValue={min}
      name={name}
      value={value}
      onChange={e => onChange(e, { type: 'range', name })}
      disabled={disabled}
      step={step}
    />
  </div>
);

export default IframeConstructorRangeControl;
